//export const BASE_URL_API =`http://localhost:8000/api`
//export const BASE_URL_API =`https://sxp6238.uta.cloud/wdphase4/api/`
export const BASE_URL_API =`https://axm1332.uta.cloud/API/`;